module.exports = __webpack_public_path__ + "img/Application_platform_pic01.2f037052.jpg";